// ============================================================
// Mock Transactions Data
// ============================================================
// Scoped by schoolId

import { mockStudents } from './students';

const generatedTransactions = {};

let txnIdCounter = 1;

mockStudents.forEach((student, index) => {
  if (!generatedTransactions[student.schoolId]) {
    generatedTransactions[student.schoolId] = [];
  }

  // 30% are cleared (no pending fees) -> these have paid
  // index % 3 === 0 means they paid their fees in full (50000)
  if (index % 3 === 0) {
    generatedTransactions[student.schoolId].push({
      id: `txn-${txnIdCounter++}`,
      receiptNumber: `RCPT-2026-${String(txnIdCounter).padStart(4, '0')}`,
      studentId: student.admissionNumber,
      studentName: `${student.firstName} ${student.lastName}`,
      gender: student.gender,
      classId: student.classId || 'class-1',
      className: student.className || 'Grade 1',
      sectionName: student.sectionName || 'Section A',
      rollNumber: student.rollNumber || 'N/A',
      feeHeadId: 'fee-str-1',
      feeHeadName: 'Yearly Tuition Fee',
      amount: 50000,
      paymentMethod: ['Cash', 'UPI', 'Bank Transfer', 'Card'][txnIdCounter % 4],
      collectedBy: 'Admin',
      status: 'success',
      date: `2026-07-${String((index % 28) + 1).padStart(2, '0')}T10:30:00Z`,
    });
  }
});

export const mockTransactions = generatedTransactions;
